import { create } from "zustand";

type Reward = {
  amount: number;
  type: string;
};

type Notification = {
  type: "Success" | "Error" | "Warning";
  message: string;
  rewards?: Reward[];
};

type NotificationStore = {
  showNotification: boolean;
  notification: Notification;
  notificationQueue: Notification[];
  setNotification: (notification: Notification) => void;
  closeNotification: () => void;
};

let notificationTimer: NodeJS.Timeout | null = null;

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  showNotification: false,
  notification: {
    type: "Error",
    message: "Something went wrong",
    rewards: [],
  },
  notificationQueue: [],

  setNotification: (notification) => {
    const { showNotification } = get();

    const startTimer = () => {
      if (notificationTimer) {
        clearTimeout(notificationTimer);
      }
      notificationTimer = setTimeout(() => {
        const state = get();
        if (state.notificationQueue.length > 0) {
          const [nextNotification, ...remainingQueue] = state.notificationQueue;
          set({
            notification: nextNotification,
            notificationQueue: remainingQueue,
            showNotification: true,
          });
          startTimer();
        } else {
          set({ showNotification: false });
        }
      }, 2500);
    };

    if (!showNotification) {
      set({
        showNotification: true,
        notification: notification,
      });
      startTimer();
    } else {
      set((state) => ({
        notificationQueue: [...state.notificationQueue, notification],
      }));
    }
  },

  closeNotification: () => {
    if (notificationTimer) {
      clearTimeout(notificationTimer);
      notificationTimer = null;
    }

    const state = get();
    if (state.notificationQueue.length > 0) {
      const [nextNotification, ...remainingQueue] = state.notificationQueue;
      set({
        notification: nextNotification,
        notificationQueue: remainingQueue,
        showNotification: true,
      });
      notificationTimer = setTimeout(() => {
        const currentState = get();
        if (currentState.notificationQueue.length > 0) {
          const [next, ...rest] = currentState.notificationQueue;
          set({
            notification: next,
            notificationQueue: rest,
            showNotification: true,
          });
        } else {
          set({ showNotification: false });
        }
      }, 43333000);
    } else {
      set({ showNotification: false });
    }
  },
}));
